import React, { useState, useEffect } from 'react';
import './Style/AllUsers.css'; // Make sure to add the new styles here
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';
import UseAppItemsUse from './UseAppItemsUse';

const AppItemsUse = () => {
    const { appitemsuse, loading } = UseAppItemsUse();

    // If loading, show loading component
    if (loading) {
        return <Loading />;
    }

    // Dynamic aggregation logic: Calculates total records grouped by their 'type'
    const getTypeCounts = () => {
        if (!appitemsuse) return {};
        return appitemsuse.reduce((acc, item) => {
            if (item.type) {
                acc[item.type] = (acc[item.type] || 0) + 1;
            }
            return acc;
        }, {});
    };

    const typeCounts = getTypeCounts();

    const toIST = (dateString) => {
        if (!dateString) return 'Loading...';
        const date = new Date(dateString);
        if (isNaN(date)) return dateString;

        const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
        return istDate.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    return (
        <div className="all-user-data-container">
            <div className="user-data-content-wrapper">
                <TopNavbar name="All Users Data" />

                {/* --- TOP SUMMARY CARDS SECTION --- */}
                <div className="stats-overview-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: '15px',
                    marginBottom: '25px',
                    marginTop: '15px'
                }}>
                    {/* Overall Total Card */}
                    <div className="stat-summary-card" style={{
                        background: '#eef2ff',
                        borderLeft: '5px solid #4f46e5',
                        padding: '15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                        <h4 style={{ margin: '0 0 5px 0', color: '#4f46e5', fontSize: '14px', textTransform: 'uppercase' }}>Total Hits</h4>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#1f2937' }}>
                            {appitemsuse ? appitemsuse.length : 0}
                        </p>
                    </div>

                    {/* Dynamically Generated Breakdown Cards */}
                    {Object.keys(typeCounts).map((typeName) => (
                        <div key={typeName} className="stat-summary-card" style={{
                            background: '#fff',
                            borderLeft: '5px solid #10b981',
                            padding: '15px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                            border: '1px solid #e5e7eb',
                            borderLeftWidth: '5px'
                        }}>
                            <h4 style={{ margin: '0 0 5px 0', color: '#4b5563', fontSize: '14px', textTransform: 'capitalize' }}>
                                {typeName.replace(/([A-Z])/g, ' $1')} {/* Formats camelCase types cleanly */}
                            </h4>
                            <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#111827' }}>
                                {typeCounts[typeName]}
                            </p>
                        </div>
                    ))}
                </div>
                {/* ---------------------------------- */}

                <div className="user-data-card">
                    <h2 className="user-data-title">All Items Information</h2>
                    
                    <div className="table-responsive">
                        <table className="user-data-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Id</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appitemsuse && appitemsuse.length > 0 ? (
                                    appitemsuse.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{item.name || 'Loading...'}</td>
                                            <td><span className="type-badge">{item.type || 'Loading...'}</span></td>
                                            <td>{toIST(item.date) || 'Loading...'}</td>
                                            <td>{item.id || 'Loading...'}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="no-data-message">
                                            No items found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="user-data-stats">
                        <p>Total Records Listed: <strong>{appitemsuse ? appitemsuse.length : 0}</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppItemsUse;